import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MasterInformationService } from '../../../../Services/master-information.service';
import { apiEndPoints } from '../../../../api/apiEndPoint';
import { SharedService } from '../../../../Services/shared.service';
import { ReportsService } from '../../../../Services/reports.service';

@Component({
  selector: 'app-user-menu-config',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbAccordionModule],
  templateUrl: './user-menu-config.component.html',
  styleUrl: './user-menu-config.component.scss',
})
export class UserMenuConfigComponent implements OnInit {
  selectedUserType: any = '';

  subMenus: any[] = [];

  menuItemsFromResponse: any[] = [];

  menusToShowInList: any[] = [];

  optionsForUserType: any[] = [];

  isEditMode: boolean = false;

  menusForShowInConfig: any[] = [];

  mainMenuList: any;

  userTypeOptions = [
    {
      userType: '5',
      userTypeName: 'Admin',
    },
    {
      userType: '7',
      userTypeName: 'Super Executive',
    },
    {
      userType: '8',
      userTypeName: 'Super Finance',
    },
    {
      userType: '9',
      userTypeName: 'Executive',
    },
    {
      userType: '10',
      userTypeName: 'Finance',
    },
  ];
  subMenuList: any;
  selectedMainMenuId: any;
  selectedSubMenuId: any;
  selectedMainMenuIds: any;
  selectedSubMenuIds: any;
  menuMappingList: any;
  menuConfigModalRef: any;
  loginData: any;
  userType: any;
  userTypeList: any;

  constructor(
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private reportService: ReportsService
  ) { }

  /* OnInit */

  ngOnInit(): void {
    this.loginData = this.sharedService.getLoginData();
    this.userType = this.loginData?.userType;

    this.getMainMenuList();
    this.getMenuMapping();
    this.getUserType();
  }

  /* UserType List */

  getUserType() {
    this.reportService.getUserTypeList(apiEndPoints.userType).subscribe({
      next: (response: any) => {
        let userType = [5, 7, 8, 9, 10, 11];
        this.userTypeList = response.body.details.filter((item: any) => userType.includes(item.id));
        console.log(this.userTypeList)

      },
      error: (error) => {
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }

  /* MainMenu List Api */

  getMainMenuList() {
    this.masterService.getMainmenu(apiEndPoints.sideMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.mainMenuList = response.body.details;
          this.getSubmenuList();
        }
      },
      error: (error) => {
        this.toastr.error(
          'Error Getting MainMenu. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  /* Submenu List Api */

  getSubmenuList() {
    this.masterService.getSubmenu(apiEndPoints.subMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.subMenuList = response.body.details;
          this.mapMenuWithSubmenu();
        }
      },
      error: (error) => {
        this.toastr.error(
          'Error Getting SubMenu. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  /* Get Menu Mapping List Api */

  getMenuMapping() {
    this.masterService
      .getMenuMappingList(apiEndPoints.getMenuMapping)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            const details = response.body.details;
            console.log(details);
            this.menuMappingList = this.groupByUserType(details);
            console.log('menu mapping', this.menuMappingList)
          }
        },
      });
  }

  /* Function to map submenus to main menu */

  mapMenuWithSubmenu() {
    this.mainMenuList.forEach((menu: any) => {
      menu.subMenus = this.subMenuList.filter(
        (submenu: any) => submenu.mainMenuId === menu.id
      );
    });
  }

  /* Group the UserType for the list */

  groupByUserType(details: any[]) {
    const groupedData: any = {};

    details.forEach((item) => {
      const { userType, mainMenuId, subMenuId } = item;

      // if (userType !== 7 && userType !== 8) {
      //   return; 
      // }
      if (userType == 6) {
        return;
      }


      if (!groupedData[userType]) {
        groupedData[userType] = [];
      }

      let mainMenu = groupedData[userType].find((menu: any) => menu.mainMenuId === mainMenuId);

      if (!mainMenu) {
        mainMenu = { mainMenuId, subMenus: [] };
        groupedData[userType].push(mainMenu);
      }

      mainMenu.subMenus.push({ subMenuId });
    });

    return Object.keys(groupedData)
      .map(userType => ({
        userType: Number(userType),
        menus: groupedData[userType]
      }))
      .filter(item => item.userType != 6);
  }


  /* MainMenu CheckBox Selection */

  onCheckboxChange(mainIndex: number, event: any) {
    const mainMenuItem = this.mainMenuList[mainIndex];
    mainMenuItem.isSelected = event.target.checked;
    this.selectedMainMenuId = mainMenuItem.mainMenuId;

    mainMenuItem.subMenus.forEach((submenu: any) => {
      submenu.isSelected = mainMenuItem.isSelected;
    });
    this.updateSelectedIds();
  }

  /* SubMenu CheckBox Selection */

  onSubmenuCheckboxChange(
    parentIndex: number,
    event: any,
    submenuIndex: number
  ) {
    const parentMenuItem = this.mainMenuList[parentIndex];
    const submenuItem = parentMenuItem.subMenus[submenuIndex];
    submenuItem.isSelected = event.target.checked;

    const allSubmenusDeselected = parentMenuItem.subMenus.every(
      (submenu: any) => !submenu.isSelected
    );
    parentMenuItem.isSelected = !allSubmenusDeselected;

    this.updateSelectedIds();
  }

  updateSelectedIds() {
    this.selectedMainMenuIds = this.mainMenuList
      .filter((menu: any) => menu.isSelected)
      .map((menu: any) => menu.id);

    this.selectedSubMenuIds = this.mainMenuList
      .flatMap((menu: any) => menu.subMenus)
      .filter((submenu: any) => submenu.isSelected)
      .map((submenu: any) => submenu.id);
  }

  /* Add Menu Config Api */

  addMenuConfig() {
    const reqBody = {
      userType: this.selectedUserType,
      userId: 0,
      mainMenuMappingList: this.selectedMainMenuIds.map(
        (mainMenuId: number) => {
          const filteredSubMenus = this.subMenuList
            .filter(
              (subMenu: any) =>
                subMenu.mainMenuId === mainMenuId && subMenu.isSelected
            )
            .map((subMenu: any) => ({
              subMenuId: subMenu.id,
            }));

          return {
            mainMenuId: mainMenuId,
            subMenuMappingLst: filteredSubMenus.length > 0 ? filteredSubMenus : [{ subMenuId: 0 }]
          };
        }
      )

    };

    this.masterService
      .addMenuMapping(apiEndPoints.addMenuConfig, reqBody)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.toastr.success('Menu Configured Successfully', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });
            this.getMenuMapping();
            this.modalService.dismissAll();
          }
        },
        error: (error) => {
          this.toastr.error(
            'Error Adding Menu. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  /* Update Menu Mapping List */

  editMenuConfig() {
    this.isEditMode = true;
    const reqBody = {
      userType: this.selectedUserType,
      userId: 0,
      mainMenuMappingList: this.selectedMainMenuIds.map(
        (mainMenuId: number) => {
          const filteredSubMenus = this.subMenuList
            .filter(
              (subMenu: any) =>
                subMenu.mainMenuId === mainMenuId && subMenu.isSelected
            )
            .map((subMenu: any) => ({
              subMenuId: subMenu.id,
            }));

          return {
            mainMenuId: mainMenuId,
            subMenuMappingLst: filteredSubMenus.length > 0 ? filteredSubMenus : [{ subMenuId: 0 }]
          };
        }
      )
    };

    this.masterService
      .addMenuMapping(apiEndPoints.updateMenuConfig, reqBody)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.toastr.success('Menu Updated Successfully', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });
            this.getMenuMapping();
            this.modalService.dismissAll();
          }
        },
        error: (error) => {
          this.toastr.error(
            'Error Updating Menu. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  /* Reset the checkboxes */

  resetSelections() {
    this.mainMenuList.forEach((mainMenu: any) => {
      mainMenu.isSelected = false;
      if (mainMenu.subMenus) {
        mainMenu.subMenus.forEach((subMenu: any) => {
          subMenu.isSelected = false;
        });
      }
    });
    this.selectedMainMenuIds = [];
    this.selectedSubMenuIds = [];
    this.selectedUserType = [];
  }

  openAddMenuConfigModal(modal: any) {
    this.resetSelections();
    this.isEditMode = false;
    this.menusForShowInConfig = this.menuItemsFromResponse;
    this.menuConfigModalRef = this.modalService.open(modal, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  openEditMenuConfigModal(menu: any, modal: any) {
    console.log(menu)
    this.isEditMode = true;
    this.menusForShowInConfig = menu.menus;
    this.selectedUserType = menu.userType;

    // Store selected main and sub menu IDs
    this.selectedMainMenuIds = menu.menus.map((menu: any) => menu.mainMenuId);
    this.selectedSubMenuIds = menu.menus.flatMap((menu: any) =>
      menu.subMenus.map((subMenu: any) => subMenu.subMenuId)
    );

    this.mainMenuList.forEach((mainMenu: any) => {
      mainMenu.isSelected = this.selectedMainMenuIds.includes(mainMenu.id);

      mainMenu.subMenus.forEach((subMenu: any) => {
        subMenu.isSelected = this.selectedSubMenuIds.includes(subMenu.id);
      });
    });

    this.optionsForUserType = [
      {
        userType: '4',
        userTypeName: 'Super Executive',
      },
      {
        userType: '5',
        userTypeName: 'Super Finance',
      },
    ];

    this.menuConfigModalRef = this.modalService.open(modal, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  onSubmit() {
    if (!this.isEditMode) {
      this.addMenuConfig();
    }

    if (this.isEditMode) {
      this.editMenuConfig();
    }
  }

}
